import ClassNames from 'classnames'
import React from 'react'
import {
  Grid,
  Text
} from './../../../components'
import {
  CONTENTS,
  ICONS,
  LOGOS,
} from './../../../themes'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'
import {
  ImageBase
} from './../../base'
import { ImageWrapper } from './styled'

export class Image extends React.PureComponent {
  render() {
    const {
      className,
      ui,
      phoneId,
      phoneNumber
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
    )

    return (
      <React.Fragment>
        {(() => {
          switch (ui) {
            case 'logoLogin':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='369'
                  widthRatioUnit='px'
                  heightRatio='60'
                  heightRatioUnit='px'
                  src={LOGOS['blue-scope-logo.png']}
                // src={LOGOS['logo.png']}
                />
              )
            case 'logoCms':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='160'
                  widthRatioUnit='px'
                  heightRatio='23'
                  heightRatioUnit='px'
                  src={LOGOS['logo.png']}
                />
              )
            case 'user':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='42'
                  widthRatioUnit='px'
                  heightRatio='42'
                  heightRatioUnit='px'
                  borderRadius='21'
                />
              )
            case 'userUpload':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='130'
                  widthRatioUnit='px'
                  heightRatio='130'
                  heightRatioUnit='px'
                  borderRadius='65'
                />
              )
            case 'uploadImage':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='100'
                  widthRatioUnit='%'
                  heightRatio='200'
                  heightRatioUnit='px'
                  borderRadius='1'
                />
              )
            case 'iconArrowDropdownUser':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='17'
                  widthRatioUnit='px'
                  heightRatio='10'
                  heightRatioUnit='px'
                  src={ICONS['ic-arrow-dropdown-user.svg']}
                />
              )
            case 'iconNotification':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='16'
                  widthRatioUnit='px'
                  heightRatio='21'
                  heightRatioUnit='px'
                  src={ICONS['ic-notification.svg']}
                />
              )
            case 'iconNotificationActive':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='21'
                  heightRatioUnit='px'
                  src={ICONS['ic-notification-active.svg']}
                />
              )
            case 'iconLogout':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='21'
                  widthRatioUnit='px'
                  heightRatio='17'
                  heightRatioUnit='px'
                  src={ICONS['ic-logout.svg']}
                />
              )
            case 'iconHome':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='16'
                  heightRatioUnit='px'
                  src={ICONS['ic-home.svg']}
                  top='1'
                />
              )
            case 'iconYearWarranty':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='19'
                  widthRatioUnit='px'
                  heightRatio='20'
                  heightRatioUnit='px'
                  src={ICONS['ic-isometric-square-white.svg']}
                  top='1'
                />
              )
            case 'iconSalesTransaction':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-sales-transaction.svg']}
                  top='0'
                  left='2'
                />
              )
            case 'iconUploadTransaction':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='15'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-upload.svg']}
                  top='0'
                />
              )
            case 'iconWarranty':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='16'
                  widthRatioUnit='px'
                  heightRatio='20'
                  heightRatioUnit='px'
                  src={ICONS['ic-warranty.svg']}
                  top='-1'
                />
              )
            case 'iconInventory':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='22'
                  widthRatioUnit='px'
                  heightRatio='21'
                  heightRatioUnit='px'
                  src={ICONS['ic-inventory.svg']}
                  top='-1'
                />
              )
            case 'iconCustomers':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='23'
                  widthRatioUnit='px'
                  heightRatio='16'
                  heightRatioUnit='px'
                  src={ICONS['ic-customers.svg']}
                  top='1'
                  left='-2'
                />
              )
            case 'iconRewards':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='16'
                  heightRatioUnit='px'
                  src={ICONS['ic-rewards.svg']}
                  top='1'
                />
              )
            case 'iconReport':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='19'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-report.svg']}
                  top='-1'
                />
              )
            case 'iconSettings':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-settings.svg']}
                  top='2'
                />
              )
            case 'iconArrowSideMenu':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='7'
                  widthRatioUnit='px'
                  heightRatio='12'
                  heightRatioUnit='px'
                  src={ICONS['ic-arrow-sidemenu.svg']}
                />
              )
            case 'iconSearch':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-search.svg']}
                />
              )
            case 'iconArrowAscending':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='9'
                  widthRatioUnit='px'
                  heightRatio='5'
                  heightRatioUnit='px'
                  src={ICONS['ic-arrow-sort-ascending.svg']}
                  top='-1'
                />
              )
            case 'iconArrowDescending':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='9'
                  widthRatioUnit='px'
                  heightRatio='5'
                  heightRatioUnit='px'
                  src={ICONS['ic-arrow-sort-descending.svg']}
                  top='-1'
                />
              )
            case 'iconFlagField':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='12'
                  heightRatioUnit='px'
                  top='5'
                />
              )
            case 'iconFlag':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='12'
                  heightRatioUnit='px'
                />
              )
            case 'iconContact':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='33'
                  widthRatioUnit='px'
                  heightRatio='33'
                  heightRatioUnit='px'
                  top='-5'
                  src={ICONS['ic-contact.svg']}
                />
              )
            case 'iconWebsite':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='32'
                  widthRatioUnit='px'
                  heightRatio='32'
                  heightRatioUnit='px'
                  top='-5'
                  src={ICONS['ic-website.svg']}
                />
              )
            case 'iconArrowGoto':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='8'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-arrow-goto.svg']}
                />
              )
            case 'iconInfoError':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='17'
                  widthRatioUnit='px'
                  heightRatio='17'
                  heightRatioUnit='px'
                  src={ICONS['ic-info-error.svg']}
                />
              )
            case 'iconInfo':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='17'
                  widthRatioUnit='px'
                  heightRatio='17'
                  heightRatioUnit='px'
                  src={ICONS['ic-notification-info.svg']}
                />
              )
            case 'iconInfoLabel':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='17'
                  widthRatioUnit='px'
                  heightRatio='17'
                  heightRatioUnit='px'
                  src={ICONS['ic-notification-info.svg']}
                  top='-2'
                />
              )
            case 'iconBlankCustomer':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='66'
                  widthRatioUnit='px'
                  heightRatio='66'
                  heightRatioUnit='px'
                  src={ICONS['ic-blank-customer.svg']}
                />
              )
            case 'iconBlankProduct':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='74'
                  widthRatioUnit='px'
                  heightRatio='68'
                  heightRatioUnit='px'
                  src={ICONS['ic-blank-product.svg']}
                />
              )
            case 'iconSymbolTrained':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='84'
                  widthRatioUnit='px'
                  heightRatio='84'
                  heightRatioUnit='px'
                  src={ICONS['ic-symbol-trained.svg']}
                />
              )
            case 'flagWithPhoneIdAndNumber':
              return (
                <Grid gutter='10'>
                  <Grid.Column>
                    <Grid gutter='5'>
                      <Grid.Column>
                        <ImageWrapper
                          {...this.props}
                          className={classes}
                          widthRatio='18'
                          widthRatioUnit='px'
                          heightRatio='12'
                          heightRatioUnit='px'
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Text
                          regular14
                          color={VARIABLES.COLORS.BLACK}
                        >
                          +{phoneId}
                        </Text>
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column>
                    <Text
                      regular14
                      color={VARIABLES.COLORS.BLACK}
                    >
                      {phoneNumber}
                    </Text>
                  </Grid.Column>
                </Grid>
              )
            case 'iconSelectedActive':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='16'
                  widthRatioUnit='px'
                  heightRatio='16'
                  heightRatioUnit='px'
                  src={ICONS['ic-selected-active.svg']}
                  top='-1'
                />
              )
            case 'iconSelectedInactive':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='16'
                  widthRatioUnit='px'
                  heightRatio='16'
                  heightRatioUnit='px'
                  src={ICONS['ic-selected-inactive.svg']}
                  top='-1'
                />
              )
            case 'iconUnitMinus':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-unit-minus.svg']}
                  top='-3'
                />
              )
            case 'iconUnitPlus':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-unit-plus.svg']}
                  top='-3'
                />
              )
            case 'iconOrderInquiry':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='26'
                  widthRatioUnit='px'
                  heightRatio='22'
                  heightRatioUnit='px'
                  src={ICONS['ic-order-inquiry.svg']}
                  top='-2'
                  left='3'
                />
              )
            case 'iconNotificationOrderInquiry':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='42'
                  widthRatioUnit='px'
                  heightRatio='42'
                  heightRatioUnit='px'
                  src={ICONS['ic-notification-order-inquiry.svg']}
                />
              )
            case 'iconArrowNotification':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='8'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-arrow-notification.svg']}
                />
              )
            case 'iconArrowViewMoreOpen':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='8'
                  widthRatioUnit='px'
                  heightRatio='5'
                  heightRatioUnit='px'
                  src={ICONS['ic-arrow-viewmore-open.svg']}
                />
              )
            case 'iconArrowViewMoreClose':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='8'
                  widthRatioUnit='px'
                  heightRatio='5'
                  heightRatioUnit='px'
                  src={ICONS['ic-arrow-viewmore-close.svg']}
                />
              )
            case 'iconSelectedItem':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='10'
                  widthRatioUnit='px'
                  heightRatio='8'
                  heightRatioUnit='px'
                  src={ICONS['ic-checkbox.svg']}
                />
              )
            case 'iconActionSalesHistory':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='16'
                  widthRatioUnit='px'
                  heightRatio='11'
                  heightRatioUnit='px'
                  src={ICONS['ic-action-sales-history.svg']}
                />
              )
            case 'iconActionPointsDetail':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='12'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-action-points-detail.svg']}
                />
              )
            case 'iconActionRewardRedemptionHistory':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='12'
                  heightRatioUnit='px'
                  src={ICONS['ic-action-reward-redemption-history.svg']}
                />
              )
            case 'iconActionEdit':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='11'
                  widthRatioUnit='px'
                  heightRatio='11'
                  heightRatioUnit='px'
                  src={ICONS['ic-action-edit.svg']}
                />
              )
            case 'iconChecked':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='10'
                  widthRatioUnit='px'
                  heightRatio='8'
                  heightRatioUnit='px'
                  src={ICONS['ic-checkbox.svg']}
                />
              )
            case 'iconBarChart':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='60'
                  widthRatioUnit='px'
                  heightRatio='21'
                  heightRatioUnit='px'
                />
              )
            case 'iconArrowStatistic':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='8'
                  widthRatioUnit='px'
                  heightRatio='10'
                  heightRatioUnit='px'
                />
              )
            case 'iconShare':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='17'
                  widthRatioUnit='px'
                  heightRatio='17'
                  heightRatioUnit='px'
                  src={ICONS['ic-share-blue-circle.svg']}
                />
              )
            case 'logoBlueScope':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='82'
                  widthRatioUnit='px'
                  heightRatio='50'
                  heightRatioUnit='px'
                  src={LOGOS['logo-blue.png']}
                />
              )
            case 'logoBlueScopeZacs':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='72'
                  widthRatioUnit='px'
                  heightRatio='50'
                  heightRatioUnit='px'
                  src={LOGOS['logo-bluescope-zacs.jpg']}
                />
              )
            case 'logoColorbond':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='140'
                  widthRatioUnit='px'
                  heightRatio='25'
                  heightRatioUnit='px'
                  src={LOGOS['logo-colorbond.jpg']}
                />
              )
            case 'logoCrp':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='218'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={LOGOS['logo-crp.jpg']}
                />
              )
            case 'logoJingjoeLek':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='45'
                  widthRatioUnit='px'
                  heightRatio='50'
                  heightRatioUnit='px'
                  src={LOGOS['logo-jingjoe-lek.jpg']}
                />
              )
            case 'logoPrima':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='77'
                  widthRatioUnit='px'
                  heightRatio='25'
                  heightRatioUnit='px'
                  src={LOGOS['logo-prima.jpg']}
                />
              )
            case 'logoSuperDyma':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='121'
                  widthRatioUnit='px'
                  heightRatio='25'
                  heightRatioUnit='px'
                  src={LOGOS['logo-superdyma.jpg']}
                />
              )
            case 'logoTrueCore':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='125'
                  widthRatioUnit='px'
                  heightRatio='25'
                  heightRatioUnit='px'
                  src={LOGOS['logo-truecore.jpg']}
                />
              )
            case 'logoZincalume':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='131'
                  widthRatioUnit='px'
                  heightRatio='25'
                  heightRatioUnit='px'
                  src={LOGOS['logo-zincalume.jpg']}
                />
              )
            case 'iconViewWarranty':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='13'
                  widthRatioUnit='px'
                  heightRatio='16'
                  heightRatioUnit='px'
                  src={ICONS['ic-document-blue.svg']}
                />
              )
            case 'iconEditWarranty':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='11'
                  widthRatioUnit='px'
                  heightRatio='11'
                  heightRatioUnit='px'
                  src={ICONS['ic-action-edit.svg']}
                />
              )
            case 'iconStatusDefault':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-status-default.svg']}
                />
              )
            case 'iconStatusSuccess':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-status-success.svg']}
                />
              )
            case 'iconStatusFail':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-status-fail.svg']}
                />
              )
            case 'iconErrorNote':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='12'
                  widthRatioUnit='px'
                  heightRatio='16'
                  heightRatioUnit='px'
                  src={ICONS['ic-error-note.svg']}
                />
              )
            case 'iconMedalGold':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatioUnit='px'
                  heightRatioUnit='px'
                  src={ICONS['ic-medal-coin-gold.png']}
                />
              )
            case 'iconMedalSilver':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatioUnit='px'
                  heightRatioUnit='px'
                  src={ICONS['ic-medal-coin-silver.png']}
                />
              )
            case 'iconMedalBronze':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatioUnit='px'
                  heightRatioUnit='px'
                  src={ICONS['ic-medal-coin-bronze.png']}
                />
              )
            case 'iconDocuments':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-documents-blue.svg']}
                />
              )
            case 'iconDocument':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='11'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-document-blue.svg']}
                />
              )
            case 'warrantyMalaysiaTermsAndConditionsLabel':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='300'
                  widthRatioUnit='px'
                  heightRatio='12'
                  heightRatioUnit='px'
                  src={CONTENTS['warranty-malaysia-terms-and-conditions-label.jpg']}
                />
              )
            case 'iconPreSalesTransaction':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-pre-sales-transaction.svg']}
                  top='2'

                />
              )
            case 'iconProjectReference':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-reference-white.svg']}
                  top='-1'
                />
              )
            case 'iconDownload':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-dowload-circle-outline-blue.svg']}
                  top='-1'
                />
              )
            case 'iconWarrantyGenerate':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='17'
                  heightRatioUnit='px'
                  src={ICONS['ic-warranty-generate.svg']}
                  top='-1'
                />
              )
            case 'iconViewImage':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='14'
                  widthRatioUnit='px'
                  heightRatio='14'
                  heightRatioUnit='px'
                  src={ICONS['ic-photo.svg']}
                  top='-1'
                />
              )
            case 'iconViewDocument':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='12'
                  widthRatioUnit='px'
                  heightRatio='15'
                  heightRatioUnit='px'
                  src={ICONS['ic-document-fill-blue.svg']}
                  top='-1'
                />
              )
            case 'iconNotificationManagement':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='18'
                  widthRatioUnit='px'
                  heightRatio='18'
                  heightRatioUnit='px'
                  src={ICONS['ic-notification-menu-white.svg']}
                  top='2'
                />
              )
            case 'logoResetPass':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='180'
                  widthRatioUnit='px'
                  heightRatio='110'
                  heightRatioUnit='px'
                  src={LOGOS['logo-blue-scope.svg']}
                />
              )
            case 'logoBs':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='294'
                  widthRatioUnit='px'
                  heightRatio='117'
                  heightRatioUnit='px'
                  src={LOGOS['logo-bs-white.svg']}
                />
              )
            case 'iconLocation':
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                  widthRatio='20'
                  widthRatioUnit='px'
                  heightRatio='20'
                  heightRatioUnit='px'
                  src={ICONS['ic-location-blue.svg']}
                />
              )
            default:
              return (
                <ImageWrapper
                  {...this.props}
                  className={classes}
                />
              )
          }
        })()}
      </React.Fragment>
    )
  }

  static defaultProps = {
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
